// extracted by mini-css-extract-plugin
export default {"informationBlockLink":"ServiceDetailContacts_informationBlockLink__PfUHL","emailLink":"ServiceDetailContacts_emailLink__oGdpx","phone":"ServiceDetailContacts_phone__VTaMh"};